import { render } from "./PartnerJobs.vue?vue&type=template&id=21662826&scoped=true"
import script from "./PartnerJobs.vue?vue&type=script&lang=js"
export * from "./PartnerJobs.vue?vue&type=script&lang=js"

import "./PartnerJobs.vue?vue&type=style&index=0&id=21662826&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-21662826"]])

export default __exports__